import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-white" }
const _hoisted_2 = { class: "min-h-screen bg-white" }
const _hoisted_3 = { class: "md:flex md:h-screen" }
const _hoisted_4 = { class: "sticky top-0 md:h-screen flex items-center justify-center p-8" }
const _hoisted_5 = { class: "w-full max-w-lg" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "p-12 space-y-12" }
const _hoisted_9 = { class: "space-y-6" }
const _hoisted_10 = { class: "text-4xl font-bold text-gray-900" }
const _hoisted_11 = { class: "flex items-baseline space-x-4" }
const _hoisted_12 = {
  key: 0,
  class: "text-xl line-through"
}
const _hoisted_13 = { class: "text-3xl font-bold text-red-600" }
const _hoisted_14 = { class: "space-y-4" }
const _hoisted_15 = { class: "text-gray-700 leading-relaxed space-y-4" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 2 }
const _hoisted_19 = { class: "space-y-8" }
const _hoisted_20 = { class: "space-y-4" }
const _hoisted_21 = { class: "flex flex-wrap gap-3" }
const _hoisted_22 = ["onClick", "title"]
const _hoisted_23 = { class: "text-sm text-gray-600" }
const _hoisted_24 = {
  key: 0,
  class: "space-y-4"
}
const _hoisted_25 = { class: "flex flex-wrap gap-3" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "text-sm text-gray-600" }
const _hoisted_28 = { class: "py-20 px-12 bg-gray-50" }
const _hoisted_29 = { class: "max-w-6xl mx-auto" }
const _hoisted_30 = { class: "grid grid-cols-1 md:grid-cols-3 gap-8" }
const _hoisted_31 = { class: "text-center space-y-4" }
const _hoisted_32 = { class: "text-xl font-semibold text-gray-900" }
const _hoisted_33 = { class: "text-gray-600 leading-relaxed" }
const _hoisted_34 = { class: "py-20 px-12" }
const _hoisted_35 = { class: "max-w-4xl mx-auto" }
const _hoisted_36 = { class: "space-y-4" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "text-lg font-semibold text-gray-900" }
const _hoisted_39 = { class: "px-6 py-4 bg-white border-t border-gray-200" }
const _hoisted_40 = { class: "grid md:grid-cols-2 gap-4" }
const _hoisted_41 = { class: "text-gray-600 font-medium" }
const _hoisted_42 = { class: "text-gray-900" }
const _hoisted_43 = { class: "max-w-4xl max-h-4xl p-4" }
const _hoisted_44 = ["src"]

import { ref, onMounted, watch } from "vue";

import { Swiper, SwiperSlide } from "swiper/vue";
import SwiperCore, { Pagination, Autoplay } from "swiper";
// 注册模块（Swiper 9 必须）
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
// swiper
import { useRoute, useRouter } from "vue-router";

import { getProductDetailWithPrice } from '../api/product.js';



// 根据productId获取产品数据

export default /*@__PURE__*/_defineComponent({
  __name: 'productDatails',
  setup(__props) {

SwiperCore.use([Pagination, Autoplay]);
// 引入样式
const swiperModules = [Pagination, Autoplay];

//路由
const router = useRouter();
const goBack = () => {
  router.go(-1); // 或者使用 router.back();
};

// 响应式数据
const selectedColor = ref("经典黑");
const selectedSize = ref("M");
const expandedSections = ref<number[]>([]);
const showImageModal = ref(false);
const selectedImage = ref("");
const leftSection = ref<HTMLElement>();
const rightSection = ref<HTMLElement>();

// 导入产品数据API
const route = useRoute();
const productId = ref(route.params.id || '1'); // 从动态路由参数中获取ID，默认使用ID为1的产品
const productType = ref(route.query.type || 'bikeormore'); // 从查询参数中获取type，默认使用bikeormore

// 加载状态管理
const loading = ref(false);
const error = ref(null);

// 响应式数据 - 根据产品ID动态获取
const currentProduct = ref(null);
const productImages = ref([]);
// 初始化productInfo时设置默认值，避免undefined错误
//const productInfo = ref({ name: '加载中...', price: 0, discountPrice: 0, brandStory: {} });
const productInfo = ref([]);
const productFeatures = ref([]);
const productDetails = ref([]);

// 获取产品详情的函数
const fetchProductDetail = async (productId, typeParam) => {
  loading.value = true;
  error.value = null;
  try {
    // 调用API获取产品详情，传入产品ID和类型参数
    // getProductDetailWithPrice确保详情页显示与列表页一致的价格信息
    // console.log(productId, typeParam);
    const data = await getProductDetailWithPrice(productId, typeParam);
    currentProduct.value = data;
    productImages.value = data.images;
    productInfo.value = data.info;
    productFeatures.value = data.features;
    productDetails.value = data.details;
    
    // 重置选择状态
    if (productInfo.value && productInfo.value.colors && productInfo.value.colors.length > 0) {
      selectedColor.value = productInfo.value.colors[0].name;
    }
    if (productInfo.value && productInfo.value.sizes && productInfo.value.sizes.length > 0) {
      selectedSize.value = productInfo.value.sizes[0];
    }
  } catch (err) {
    error.value = '获取产品详情失败';
    console.error('获取产品详情错误:', err);
  } finally {
    loading.value = false;
  }
};

// 初始加载产品数据
fetchProductDetail(productId.value, productType.value);

// 监听路由参数变化，更新产品数据
// 修改为分别监听params和query，使用immediate确保组件挂载时也执行
watch(
  () => route.params.id,
  (newId) => {
    console.log('ID参数变化:', newId);
    if (newId) {
      productId.value = newId as string;
      fetchProductDetail(productId.value, productType.value);
    }
  },
  { immediate: true }
);

watch(
  () => route.query.type,
  (newType) => {
    console.log('Type参数变化:', newType);
    productType.value = newType as string || 'bikeormore';
    fetchProductDetail(productId.value, productType.value);
  },
  { immediate: true }
);

// 方法
const toggleSection = (index: number) => {
  const currentIndex = expandedSections.value.indexOf(index);
  if (currentIndex > -1) {
    expandedSections.value.splice(currentIndex, 1);
  } else {
    expandedSections.value.push(index);
  }
};

const openImageModal = (image: string) => {
  selectedImage.value = image;
  showImageModal.value = true;
};

const closeImageModal = () => {
  showImageModal.value = false;
  selectedImage.value = "";
};

onMounted(() => {
  // 同步滚动效果
  if (rightSection.value) {
    rightSection.value.addEventListener("scroll", () => {
      // 这里可以添加左右联动滚动逻辑
    });
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "sticky top-0 z-30 bg-white mx-auto px-4 py-4 flex items-center border-b shadow-sm" }, [
      _createElementVNode("div", { class: "flex items-center" }, [
        _createElementVNode("button", {
          onClick: goBack,
          class: "flex items-center justify-center w-10 h-10 rounded-full hover:bg-gray-100 transition-colors duration-200"
        }, _cache[0] || (_cache[0] = [
          _createElementVNode("i", { class: "fas fa-arrow-left text-lg" }, null, -1)
        ])),
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "hidden md:block ml-2 text-gray-700" }, "返回商品列表", -1))
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "text-lg md:text-xl font-medium text-center flex-1" }, "商品详情", -1)),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "w-10 md:w-32" }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "w-full md:w-1/2 relative bg-gray-50 overflow-hidden",
          ref_key: "leftSection",
          ref: leftSection
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(Swiper), {
                modules: swiperModules,
                pagination: { clickable: true },
                autoplay: { delay: 3000 },
                class: "product-swiper"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productImages.value, (image, index) => {
                    return (_openBlock(), _createBlock(_unref(SwiperSlide), { key: index }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "aspect-square overflow-hidden rounded-lg shadow-lg cursor-pointer",
                          onClick: ($event: any) => (openImageModal(image))
                        }, [
                          _createElementVNode("img", {
                            src: image,
                            alt: `产品图片 ${index + 1}`,
                            class: "w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                          }, null, 8, _hoisted_7)
                        ], 8, _hoisted_6)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ])
          ])
        ], 512),
        _createElementVNode("div", {
          class: "w-full md:w-1/2 overflow-y-auto",
          ref_key: "rightSection",
          ref: rightSection
        }, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("h1", _hoisted_10, _toDisplayString(productInfo.value.name), 1),
              _createElementVNode("div", _hoisted_11, [
                (productInfo.value.discountPrice && productInfo.value.discountPrice > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, "¥" + _toDisplayString(productInfo.value.price ? productInfo.value.price.toLocaleString() : '0'), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_13, " ¥" + _toDisplayString((productInfo.value.discountPrice > 0 && productInfo.value.discountPrice ? productInfo.value.discountPrice.toLocaleString() : productInfo.value.price ? productInfo.value.price.toLocaleString() : '0')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "text-2xl font-semibold text-gray-900" }, "品牌故事", -1)),
              _createElementVNode("div", _hoisted_15, [
                (productInfo.value.brandStory && productInfo.value.brandStory.paragraph1)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(productInfo.value.brandStory.paragraph1), 1))
                  : _createCommentVNode("", true),
                (productInfo.value.brandStory && productInfo.value.brandStory.paragraph2)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(productInfo.value.brandStory.paragraph2), 1))
                  : _createCommentVNode("", true),
                (productInfo.value.brandStory && productInfo.value.brandStory.paragraph3)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(productInfo.value.brandStory.paragraph3), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "text-xl font-semibold text-gray-900" }, "颜色选择", -1)),
                _createElementVNode("div", _hoisted_21, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((productInfo.value.colors || []), (color) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: color.name,
                      onClick: ($event: any) => (selectedColor.value = color.name),
                      class: _normalizeClass([{
                      'ring-2 ring-blue-500': selectedColor.value === color.name,
                      'ring-1 ring-gray-300': selectedColor.value !== color.name,
                    }, "w-12 h-12 rounded-full cursor-pointer !rounded-button whitespace-nowrap transition-all duration-200 hover:scale-110"]),
                      style: _normalizeStyle(color.gradient && color.gradient.length >= 2 ? { background: `linear-gradient(135deg, ${color.gradient[0]}, ${color.gradient[1]})` } : { backgroundColor: color.value }),
                      title: color.name
                    }, null, 14, _hoisted_22))
                  }), 128))
                ]),
                _createElementVNode("p", _hoisted_23, "已选择：" + _toDisplayString(selectedColor.value), 1)
              ]),
              (productInfo.value.sizes && productInfo.value.sizes.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "text-xl font-semibold text-gray-900" }, "尺码选择", -1)),
                    _createElementVNode("div", _hoisted_25, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productInfo.value.sizes, (size) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: size,
                          onClick: ($event: any) => (selectedSize.value = size),
                          class: _normalizeClass([{
                      'bg-blue-600 text-white border-blue-600':
                        selectedSize.value === size,
                      'bg-white text-gray-700 border-gray-300 hover:border-gray-400':
                        selectedSize.value !== size,
                    }, "px-4 py-2 border-2 !rounded-button cursor-pointer whitespace-nowrap transition-all duration-200"])
                        }, _toDisplayString(size), 11, _hoisted_26))
                      }), 128))
                    ]),
                    _createElementVNode("p", _hoisted_27, "已选择：" + _toDisplayString(selectedSize.value), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ], 512)
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "text-3xl font-bold text-center text-gray-900 mb-12" }, " 产品特点 ", -1)),
          _createElementVNode("div", _hoisted_30, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productFeatures.value, (feature) => {
              return (_openBlock(), _createElementBlock("div", {
                key: feature.title,
                class: "bg-white p-8 rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300"
              }, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("h3", _hoisted_32, _toDisplayString(feature.title), 1),
                  _createElementVNode("p", _hoisted_33, _toDisplayString(feature.description), 1)
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          _cache[8] || (_cache[8] = _createElementVNode("h2", { class: "text-3xl font-bold text-center text-gray-900 mb-12" }, " 产品详细信息 ", -1)),
          _createElementVNode("div", _hoisted_36, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productDetails.value, (section, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "border border-gray-200 rounded-lg overflow-hidden"
              }, [
                _createElementVNode("button", {
                  onClick: ($event: any) => (toggleSection(index)),
                  class: _normalizeClass([{
                  'bg-gray-50': expandedSections.value.includes(index),
                  'bg-white hover:bg-gray-50':
                    !expandedSections.value.includes(index),
                }, "w-full px-6 py-4 text-left flex items-center justify-between cursor-pointer whitespace-nowrap transition-colors duration-200"])
                }, [
                  _createElementVNode("span", _hoisted_38, _toDisplayString(section.title), 1),
                  _createElementVNode("i", {
                    class: _normalizeClass([{
                    'fa-chevron-up': expandedSections.value.includes(index),
                    'fa-chevron-down': !expandedSections.value.includes(index),
                  }, "fas transition-transform duration-200"])
                  }, null, 2)
                ], 10, _hoisted_37),
                _withDirectives(_createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.items, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.label,
                        class: "flex justify-between py-2 border-b border-gray-100 last:border-b-0"
                      }, [
                        _createElementVNode("span", _hoisted_41, _toDisplayString(item.label), 1),
                        _createElementVNode("span", _hoisted_42, _toDisplayString(item.value), 1)
                      ]))
                    }), 128))
                  ])
                ], 512), [
                  [_vShow, expandedSections.value.includes(index)]
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      (showImageModal.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onClick: closeImageModal,
            class: "fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 cursor-pointer"
          }, [
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("img", {
                src: selectedImage.value,
                alt: "产品大图",
                class: "w-full h-full object-contain"
              }, null, 8, _hoisted_44)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})